import React from 'react'

class DisclaimerNl extends React.Component {
  render() {
    return <div>
      <h2>Belangrijke kennisgeving</h2>

      <h3>Verklaring van afwijzing van aansprakelijkheid</h3>

      <p>De teksten en inlichtingen op de internetsite van SenLex worden gratis ter beschikking gesteld ter informatie van het publiek.</p>

      <p>De gebruiker mag de verstrekte informatie niet beschouwen als juridisch advies.</p>

      <p>Uit de vermelding of niet-vermelding van een parlementair stuk, arrest, advies of om het even welke tekst of tekstgedeelte kan geen enkel waardeoordeel van de samensteller van de databank worden afgeleid.</p>

      <p>Alle gegevens op deze site worden geacht correct te zijn op het ogenblik van publicatie, echter zonder daaromtrent enige garantie te geven. Met andere woorden, het gebruik van deze informatie is op eigen risico. De inhoud van de site kan te allen tijde zonder aankondiging of kennisgeving worden aangepast, gewijzigd of aangevuld.</p>

      <p>De Senaat kan in geen geval door wie dan ook, op directe of indirecte, bijzondere of andere wijze aansprakelijk worden gesteld voor schade te wijten aan het gebruik van deze site of een site waarnaar een (hyper)link verwijst, en dit met inbegrip, zonder beperking, van alle verliezen, werkonderbrekingen, beschadiging van programma's of andere gegevens op het computersysteem, van apparatuur, programmatuur of andere van de gebruiker.</p>

      <p>De Databank Institutionele Aangelegenheden verbetert de door U gesignaleerde vergissingen, maar verstrekt geen antwoord op individuele vragen en geeft geen juridische bijstand met betrekking tot de identificatie, de interpretatie of de toepassing van de ter beschikking gestelde informatie.</p>
    </div>
  }
}

export default DisclaimerNl;





/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/disclaimer/nl.js
 **/